import { FC } from "react";
import { StyledDivider } from "../../styles/Card";

const CardDivider: FC = () => {
  return <StyledDivider variant="fullWidth" />
}
export default CardDivider